import React from 'react';
import PropTypes from 'prop-types';
import { PsLinkLabel } from './ps-link-label/PsLinkLabel';

export const UserLabel = (
    {
        user,
    },
) => {
    if ( !user ) {
        return null;
    }

    const completeName = user.completeName();

    return (
        <PsLinkLabel label={completeName}/>
    );
};

UserLabel.propTypes = {
    user: PropTypes.object,
};

UserLabel.defaultProps = {
    user: null,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/UserLabel.jsx